/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import styles from './content-block.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The complementary content in content block.
 *
 * @element c4d-content-block-complementary
 */
@customElement(`${c4dPrefix}-content-block-complementary`)
class C4DContentBlockComplementary extends LitElement {
  /**
   * The shadow slot this logo UI should be in.
   */
  @property({ reflect: true })
  slot = 'complementary';

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'complementary');
    }
    super.connectedCallback();
  }

  render() {
    return html` <slot></slot> `;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentBlockComplementary;
